<template>
  <component :is="'b-card'">
    <div class="physician-form">
      <b-overlay
        :show="loading"
        variant="light"
        opacity="0.3"
        blur="5px"
        rounded="sm"
      >
        <validation-observer ref="refFormObserver" #default="{ handleSubmit }">
          <b-form
            @submit.prevent="alertTabError();handleSubmit(save)"
          >
            <b-tabs
              pills
              class="g-med-tabs"
            >
              <b-tab class="g-med-tab" active @click="tabPersonError = false">
                <template #title>
                  <div>
                    <feather-icon
                      icon="UserIcon"
                      size="16"
                      class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Pessoal</span>
                    <feather-icon
                      :class="{'error-icon-show': tabPersonError}"
                      icon="AlertCircleIcon"
                      size="16"
                      class="error-icon text-danger"
                    />
                  </div>
                </template>

                <b-row>
                  <b-col cols="12" md="12" class="mb-1">
                    <b-alert
                      v-model="showAlert"
                      v-height-fade.appear
                      variant="danger"
                      dismissible
                      class="mb-0"
                    >
                      <div class="alert-body">
                        <ul class="m-0">
                          <li v-for="(message, index) of alertMessage" :key="index">
                            {{ message }}
                          </li>
                        </ul>
                      </div>
                    </b-alert>
                  </b-col>
                  <b-col cols="12" md="3">
                    <b-form-group id="cpf-input" label="CPF" label-for="cpf">
                      <validation-provider
                        #default="{ errors }"
                        name="CPF"
                        vid="cpf"
                        rules="required"
                      >
                        <b-input-group
                          label="CPF"
                          label-for="cpf"
                        >
                          <cleave
                            v-model="physician.cpf"
                            class="form-control"
                            :disabled="loadingDocument"
                            :raw="false"
                            :options="options.customDelimiter"
                          />
                          <b-input-group-append>
                            <b-button :disabled="loadingDocument" variant="outline-primary" @click="debounceSearchByCpf">
                              <feather-icon
                                v-if="!loadingDocument"
                                icon="SearchIcon"
                                size="14"
                              />
                              <feather-icon
                                v-if="loadingDocument"
                                class="spin"
                                icon="LoaderIcon"
                                size="14"
                              />
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group label="Nome completo" label-for="nome">
                      <validation-provider
                        #default="{ errors }"
                        name="Nome"
                        vid="nome"
                        rules="required"
                      >
                        <b-form-input id="nome" v-model="physician.name" :disabled="!formEnabled" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="3">
                    <b-form-group label="Nascimento" label-for="birthday">
                      <validation-provider
                        #default="{ errors }"
                        name="Nascimento"
                        vid="birthday"
                        rules="required"
                      >
                        <b-form-group>
                          <flat-pickr
                            id="birthday-datepicker"
                            v-model="birthday"
                            class="form-control"
                            :config="dateConfig"
                            :disabled="!formEnabled"
                            @on-change="changeBirthday"
                          />
                        </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group label="E-mail" label-for="email">
                      <validation-provider
                        #default="{ errors }"
                        name="email"
                        vid="email"
                        rules="required"
                      >
                        <b-form-input id="email" v-model="physician.email" :disabled="!formEnabled" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group label="Telefone" label-for="telefone">
                      <validation-provider
                        #default="{ errors }"
                        name="Telefone"
                        vid="telefone"
                        rules="required"
                      >
                        <cleave
                          id="telefone"
                          v-model="physician.phone"
                          class="form-control"
                          :raw="false"
                          :disabled="!formEnabled"
                          :options="physician.phone.length > 14 ? options.phoneWith9 : options.phone"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col cols="6" lg="4">
                        <validation-provider
                          #default="{ errors }"
                          name="Profissão"
                          vid="profession_id"
                          rules="required"
                        >
                          <b-form-group label="Profissão" label-for="profession_id">
                            <v-select
                              v-model="physician.profession_id"
                              :options="professionOptions"
                              :reduce="val => val.value"
                              :clearable="false"
                              input-id="value"
                              :disabled="!formEnabled"
                              @input="changeProfession"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group label="Nº Registro" label-for="crm">
                          <validation-provider
                            #default="{ errors }"
                            name="Nº Registro"
                            vid="crm"
                            :rules="requiredNumberRegulatoryBody ? 'required' : null"
                          >
                            <b-form-input id="crm" v-model="physician.crm" :disabled="!formEnabled" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group label="Estado do Registro" label-for="state_id">
                          <validation-provider
                            #default="{ errors }"
                            name="Estado do Registro"
                            vid="state_id"
                            :rules="requiredNumberRegulatoryBody ? 'required' : null"
                          >
                            <b-form-select
                              id="state_id"
                              v-model="physician.state_id"
                              :disabled="!formEnabled"
                              :options="crmStateOptions"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6">
                    <div>
                      <label for="textarea-default">
                        <b-form-checkbox
                          v-model="physician.schedule_restriction"
                          name="schedule-restriction"
                          class="custom-control-danger"
                          switch
                          inline
                          :disabled="!formEnabled"
                          @change="changeRestriction"
                        >
                          Com restrição?
                        </b-form-checkbox>
                      </label>
                      <b-form-textarea
                        id="textarea-default"
                        v-model="physician.schedule_restriction_reason"
                        :disabled="!physician.schedule_restriction"
                        placeholder="Descrição da restrição"
                        rows="3"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
            <b-row>
              <b-col cols="12">
                <b-button
                  variant="primary"
                  class="mt-1 mr-1"
                  type="submit"
                  @click="saveDefault"
                >
                  Salvar
                </b-button>
                <b-button
                  v-if="showErrorButton"
                  variant="danger"
                  class="mt-1 mr-1"
                  type="submit"
                  @click="physician.need_validate_manually = true"
                >
                  Salvar com ressalvas
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </div>

    <b-modal
      id="modal-physician"
      ref="physicianModal"
      title="Profissional encontrado"
      hide-footer
      centered
    >
      <div>
        <div class="mb-1">
          Profissional existente em sua instituição:
        </div>
        <div>Nome: <strong>{{ foundPhysician.name }}</strong></div>
        <div>CPF: <strong>{{ foundPhysician.cpf }}</strong></div>
        <div class="text-right">
          <b-button
            variant="primary"
            class="ml-1"
            :to="{ name: 'physician-view', params: { id: foundPhysician.id } }"
          >
            <span class="d-none d-sm-inline">Acessar cadastro</span>
          </b-button>
        </div>
      </div>
    </b-modal>
  </component>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BModal,
  BTab,
  BTabs,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BFormSelect,
  BButton,
  BFormTextarea,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
  BAlert,
  BOverlay,
} from 'bootstrap-vue'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
import store from '@/store'
import { onUnmounted, ref, watch } from '@vue/composition-api'
import { required } from '@validations'
import { provideToast, useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import formError from '@core/comp-functions/forms/form-error'
import formValidation from '@core/comp-functions/forms/form-validation'
import { sortBy, debounce } from 'lodash'
import Fuse from 'fuse.js'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { format } from 'date-fns'
import { onlyNumbers } from '@core/utils/utils'
import vSelect from 'vue-select'
import physicianStoreModule from '../physicianStoreModule'

export default {
  components: {
    vSelect,
    BOverlay,
    BAlert,
    BModal,
    BInputGroupAppend,
    flatPickr,
    BTab,
    BTabs,
    BCard,
    BForm,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BFormSelect,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    Cleave,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'height-fade': heightFade,
    Ripple,
  },
  data() {
    return {
      dateConfig: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
      },
      options: {
        cnpjDelimiter: {
          delimiters: ['.', '.', '/', '-'],
          blocks: [2, 3, 3, 4, 2],
          numericOnly: true,
        },
        customDelimiter: {
          delimiters: ['.', '.', '-'],
          blocks: [3, 3, 3, 2],
          numericOnly: true,
        },
        phone: {
          delimiters: ['(', ')', ' ', '-'],
          blocks: [0, 2, 0, 4, 5],
          numericOnly: true,
          delimiterLazyShow: true,
        },
        phoneWith9: {
          delimiters: ['(', ')', ' ', '-'],
          blocks: [0, 2, 0, 5, 4],
          numericOnly: true,
          delimiterLazyShow: true,
        },
        postalCode: {
          delimiters: ['-'],
          blocks: [5, 3],
          numericOnly: true,
        },
        income: {
          numeralPositiveOnly: true,
          numericOnly: true,
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralDecimalScale: 2,
          prefix: 'R$ ',
          rawValueTrimPrefix: true,
        },
      },
    }
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-physician'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) { store.registerModule(USER_APP_STORE_MODULE_NAME, physicianStoreModule) }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) { store.unregisterModule(USER_APP_STORE_MODULE_NAME) }
    })

    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 10000,
      maxToasts: 2,
      transition: 'Vue-Toastification__fade',
    })
    const toast = useToast()

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(() => {})
    const professionOptions = ref([])
    const physicianModal = ref(null)
    const physician = ref({
      cpf: '',
      phone: '',
      profession_id: '',
      schedule_restriction: false,
      schedule_restriction_reason: null,
      state_id: null,
      account: {},
      companies: [],
      cpfcnpj_error_id: null,
      need_validate_manually: false,
      motive_need_validate_manually: null,
    })
    const showErrorButton = ref(false)
    const birthday = ref(null)
    const tabPersonError = ref(false)
    const tabBankError = ref(false)
    const tabAddressError = ref(false)
    const postalCode = ref('')
    const foundPhysician = ref({})
    const stateId = ref(null)
    const cityId = ref(null)
    const cityName = ref('') // campo apenas para guardar nome da cidade que vem do consumo da api do viacep
    const street = ref('')
    const number = ref('')
    const complement = ref('')
    const neighborhood = ref('')
    const financialInstitutionId = ref('')
    const loading = ref(false)
    const loadingDocument = ref(false)
    const formEnabled = ref(false)
    const showAlert = ref(false)
    const requiredNumberRegulatoryBody = ref(true)
    const alertMessage = ref([])

    const states = ref([])
    const stateOptions = ref([])
    const crmStateOptions = ref([])
    const cities = ref([])
    const cityOptions = ref([])
    const bankOptions = ref([
      { label: 'Informe banco', value: null },
    ])
    const accountTypes = ref([
      {
        value: 'checking_account',
        text: 'Corrente',
      },
      {
        value: 'savings_account',
        text: 'Poupança',
      },
    ])

    const tabsMap = {
      // person
      cpf: tabPersonError,
      bank: tabBankError,
      nome: tabPersonError,
      email: tabPersonError,
      telefone: tabPersonError,
      crm: tabPersonError,
      state_id: tabPersonError,
      birthday: tabPersonError,
      // bank
      'account.financial_institution_id': tabBankError,
      accountType: tabBankError,
      branch_number: tabBankError,
      accountNumber: tabBankError,
      account_code: tabBankError,
      branch_code: tabBankError,
      // address
      cep: tabAddressError,
      estado: tabAddressError,
      bairro: tabAddressError,
      rua: tabAddressError,
    }

    async function alertTabError() {
      tabPersonError.value = false
      tabBankError.value = false
      tabAddressError.value = false
      await refFormObserver.value.validate()
      const { errors } = refFormObserver.value
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const field in errors) {
        if (errors[field].length > 0 && tabsMap[field]) {
          tabsMap[field].value = true
        }
      }
    }

    const accountType = ref(accountTypes.value[0])

    const fetchProfessions = () => store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchProfessions`)
      .then(response => {
        professionOptions.value = response.data.data.map(p => ({
          label: p.label,
          value: p.id,
          required_number_regulatory_body: p.required_number_regulatory_body,
        }))

        if (professionOptions.value.length === 1) { physician.value.profession_id = professionOptions.value[0].value }
      })
    fetchProfessions()

    const fetchCities = ({ stateId: state }) => store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchCities`, {
      stateId: state,
    }).then(resp => {
      cities.value = resp.data
      cityOptions.value = resp.data.map(city => ({
        value: city.id,
        text: city.name,
      }))
    })

    const getAddressByZipCode = zipCode => store.dispatch(`${USER_APP_STORE_MODULE_NAME}/getAddressByZipCode`, { zipCode })
    const getState = stateCode => states.value.find(s => s.abbreviation === stateCode)

    const changeProfession = id => {
      const profession = professionOptions.value.find(p => p.value === id)
      requiredNumberRegulatoryBody.value = profession.required_number_regulatory_body
    }

    function searchByCpf() {
      const cpf = onlyNumbers(physician.value.cpf)
      if (cpf.length < 11) { return }

      loadingDocument.value = true
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/searchPhysicianByCpf`, { cpf })
        .then(resp => {
          loadingDocument.value = false
          foundPhysician.value = resp.data.data
          if (foundPhysician.value && foundPhysician.value.exist_in_institution) {
            physicianModal.value.show()
          } else if (foundPhysician.value) {
            formEnabled.value = true
            physician.value.name = foundPhysician.value.name
            physician.value.birthday = foundPhysician.value.birthday
            physician.value.crm = foundPhysician.value.crm
            physician.value.state_id = foundPhysician.value.state_id
            birthday.value = foundPhysician.value.birthday
          }
        })
        .catch(() => {
          formEnabled.value = true
          loadingDocument.value = false
        })
    }

    const debounceSearchByCpf = debounce(() => {
      searchByCpf()
    }, 1500)

    watch(() => physician.value.cpf, () => {
      debounceSearchByCpf()
    })

    watch(postalCode, current => {
      if (current.length === 9) {
        getAddressByZipCode(current)
          .then(async data => {
            const state = getState(data.state)
            await fetchCities({ stateId: state.id })
            const city = cities.value.find(c => c.name === data.city)
            street.value = data.street
            neighborhood.value = data.neighborhood
            complement.value = data.complement
            cityId.value = city.id
            stateId.value = state.id
          })
      }
    })

    const fetchStates = () => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchStates`, {})
        .then(resp => {
          states.value = resp.data
          stateOptions.value = resp.data.map(state => ({
            value: state.id,
            text: `${state.name} (${state.abbreviation})`,
          }))
          crmStateOptions.value = resp.data.map(state => ({
            value: state.id,
            text: state.abbreviation,
          }))
          physician.value = {
            ...physician.value,
            state_id: null,
          }
        })
        .catch(err => {
          // TODO: subir um toats indicando o erro
          // eslint-disable-next-line no-console
          console.log(err)
        })
    }
    fetchStates()

    const fetchFinancialInstitutions = () => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchFinancialInstitutions`, { params: { perPage: 9999 } })
        .then(resp => {
          const banks = sortBy(resp.data, ['name'])
          bankOptions.value = banks.map(bank => ({
            value: bank.id,
            label: `${bank.name} - ${bank.bank_code}`,
          }))
        })
    }
    fetchFinancialInstitutions()

    function updateBankId() {
      if (financialInstitutionId.value) {
        physician.value.account.financial_institution_id = financialInstitutionId.value.value
      } else {
        physician.value.account.financial_institution_id = null
      }
    }

    function alertError(message) {
      toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Erro',
          icon: 'XOctagonIcon',
          variant: 'danger',
          text: message,
        },
      })
    }

    function save() {
      physician.value.account.account_type = accountType.value.value

      const body = {
        ...physician.value,
        cpf: physician.value.cpf.replace(/\D/g, ''),
        phone: physician.value.phone.replace(/\D/g, ''),
      }

      if (body.birthday && !/^\d{4}-\d{2}-\d{2}$/.test(body.birthday)) {
        alertError('Nascimento formato inválido')
        return
      }

      loading.value = true
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/storePhysician`, body)
        .then(({ data }) => {
          loading.value = false
          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Sucesso',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'Profissional cadastrado com sucesso',
            },
          })
          router.push({
            name: 'physician-edit',
            params: { id: data.id },
            query: { new: 'true', validated: physician.value.need_validate_manually ? 'true' : 'false' },
          })
        })
        .catch(error => {
          loading.value = false
          if (error.response && error.response.data && [20231011199000, 20250806205456].includes(error.response.data.error_code)) {
            showAlert.value = true
            const mapField = {
              cpf: '',
              name: '',
              birth: '',
              crm_name: 'CRM -',
              crm: 'CRM -',
            }
            const checks = error.response.data.data ? error.response.data.data.checks : []
            if (!checks.length) {
              alertMessage.value = [error.response.data.message]
              return
            }
            alertMessage.value = checks.map(c => `${mapField[c.field]} ${c.message}`)
            const cpfError = checks.length === 1
                && checks.some(c => ['name', 'crm_name'].includes(c.field) && c.metadata && !c.metadata.similarity_error)
            showErrorButton.value = cpfError

            physician.value.motive_need_validate_manually = alertMessage.value.join(', ')
            // eslint-disable-next-line no-param-reassign
            error.response.data.message = 'Dados inválidos'
          }
          const { setErrors, getErrorMessage } = formError(this.$refs.refFormObserver, error)
          setErrors()
          if (getErrorMessage()) {
            alertError(getErrorMessage())
          }
        })
    }

    function filterFinancialInstitutions(options, search) {
      const fuse = new Fuse(options, {
        keys: ['label'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    }

    function changeRestriction() {
      if (!physician.value.schedule_restriction) {
        physician.value.schedule_restriction_reason = null
      }
    }

    function changeBirthday(birth) {
      if (birth[0]) {
        physician.value.birthday = format(birth[0], 'yyyy-MM-dd')
      } else {
        physician.value.birthday = null
      }
    }

    function saveDefault() {
      physician.value.need_validate_manually = false
      physician.value.motive_need_validate_manually = null
    }

    return {
      saveDefault,
      birthday,
      changeBirthday,
      stateOptions,
      crmStateOptions,
      states,
      cities,
      cityOptions,
      required,
      physician,
      showErrorButton,
      loading,
      loadingDocument,
      postalCode,
      stateId,
      fetchCities,
      cityId,
      cityName,
      street,
      number,
      complement,
      neighborhood,
      alertMessage,
      save,
      getValidationState,
      refFormObserver,
      bankOptions,
      financialInstitutionId,
      updateBankId,
      accountType,
      accountTypes,
      tabPersonError,
      tabBankError,
      tabAddressError,
      filterFinancialInstitutions,
      alertTabError,
      changeRestriction,
      debounce,
      physicianModal,
      foundPhysician,
      debounceSearchByCpf,
      formEnabled,
      showAlert,
      professionOptions,
      changeProfession,
      requiredNumberRegulatoryBody,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.error-icon {
  margin-left: 5px;
  opacity: 0;
}
.error-icon-show {
  opacity: 1;
}
.btn-group {
  height: 38px;
}
fieldset {
  margin-bottom: 0!important;
}
@-webkit-keyframes rotation {
  from {-webkit-transform: rotate(0deg);}
  to   {-webkit-transform: rotate(359deg);}
}

.spin {
  -webkit-animation: rotation 3s infinite linear;
}
#cpf-input {

  input {
    border-right: 0;
  }
  button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
#birthday-datepicker[disabled] {
  background-color: #efefef;
}
</style>
